import React from 'react';
import clsx from 'clsx';

import styles from './InputContainer.module.scss';

interface InputContainerProps {
  className?: string;
  invalid?: boolean;
  disabled?: boolean;
}

const InputContainer = ({
  className,
  invalid,
  disabled,
  children,
}: React.PropsWithChildren<InputContainerProps>) => (
  <div
    data-invalid={invalid || undefined}
    className={clsx(
      styles.InputContainer,
      invalid && styles.invalid,
      disabled && styles.disabled,
      className,
    )}
  >
    {children}
  </div>
);

export default InputContainer;
